import React from "react";
// eslint-disable-next-line import/order
import ReactDOM from "react-dom/client";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
// eslint-disable-next-line import/order
import { Provider as ReduxStoreProvider } from "react-redux";
// eslint-disable-next-line import/order
import { QueryClientProvider } from "react-query";
// eslint-disable-next-line import/order
import { store, queryClient } from "./helpers";
// Load Bootstrap styles before importing App
// otherwise the styles break
// eslint-disable-next-line import/order
import "bootstrap/dist/css/bootstrap.css";
// eslint-disable-next-line import/order
import "react-phone-number-input/style.css";

// eslint-disable-next-line import/order
import App from "./containers/app";
import { gb } from "./helpers/growthBook";

import "./static/css/global-styles.scss";
import "./static/css/pagination.scss";

const root = ReactDOM.createRoot(document.getElementById("root")!);
gb.init({ streaming: true });

root.render(
	<GrowthBookProvider growthbook={gb}>
		<ReduxStoreProvider store={store}>
			<QueryClientProvider client={queryClient}>
				<App />
			</QueryClientProvider>
		</ReduxStoreProvider>
	</GrowthBookProvider>,
);
